module.exports = __webpack_public_path__ + "static/assets/3aa1fcd3a203f650ca99308165d842e1.svg";